/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Pagination from "../../faetures/pagination";
import {
  deleteOrder,
  getALlOrdersByPagination
} from "../../redux/actions/frontendActions/OrderActions";
import Dashboard_top_header from "../utils/Dashboard_top_header";
import HeaderSearchbar from "../utils/HeaderSearchbar";
import Sidebar from "../utils/Sidebar";
function DashboardOrder() {
  const [sidebarHide, setSidebarHide] = useState(false);
  const handleSidebarHideAndShow = (e) => {
    setSidebarHide(!sidebarHide);
  };
  const { currentPage } = useParams();
  const dispatch = useDispatch();
  const { OrderSuccessMessage, allOrders, parPage, orderCount } = useSelector(
    (state) => state.Order
  );
  useEffect(() => {
    dispatch(
      getALlOrdersByPagination(currentPage ? currentPage.split("-")[1] : 1)
    );
    if (OrderSuccessMessage) {
      toast.success(OrderSuccessMessage);
      window.location.reload();
    }
  }, [currentPage, OrderSuccessMessage]);

  return (
    <div className="dashboard-container">
      <div className="navbar-area">
        <Dashboard_top_header
          handleSidebarHideAndShow={handleSidebarHideAndShow}
          sidebarHide={sidebarHide}
        />
      </div>

      <div className="dashboard-main-flex">
        <div className="dashboard-sidebar">
          <Sidebar sidebarHide={sidebarHide} />
        </div>
        <div className="dashboard-item">
          <HeaderSearchbar page="Order" placeholder="Search Orders" />
          <Toaster
            position={"bottom-center"}
            reverseOrder={false}
            toastOptions={{
              style: {
                fontSize: "15px",
              },
            }}
          />

          <div className="dashboard_orders_wrapper_area">
            {allOrders.length > 0 ? (
              allOrders.map((order, index) => (
                <div className="single_order_box" key={index}>
                  <div className="image-tag-area">
                    <div className="img">
                      <img src={order.image} alt="image" />
                    </div>
                    <div className="name">
                      <h4>
                        {order.firstName} {order.lastName}
                      </h4>
                      <h6>{order.email}</h6>
                      <h6>{order.phone}</h6>
                      <address>{order.address}</address>
                    </div>
                  </div>

                  <div className="items">
                    <span>{order.pCategories}</span>
                    <h2>${order.pPrice}</h2>
                    <h5>{order.pName}</h5>
                    <p>{order.createdAt}</p>
                  </div>
                  <div className="delete">
                    <h5 onClick={() => dispatch(deleteOrder(order._id))}>
                   
                      
                      <FaTrash /> delete
                    </h5>
                  </div>
                </div>
              ))
            ) : (
              <h1>Loading...</h1>
            )}
          </div>
          <div className="pagination-area">
            <Pagination
              pageNumber={currentPage ? currentPage.split("-")[1] : 1}
              perPage={parPage}
              itemCount={orderCount}
              path="/admin/dashboard/all-orders"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardOrder;
